import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchOP13 = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetOP13`);
  
  return response.data.data;
};

export const useOP13 = (enabled = true) =>
  useQuery({
    queryKey: ["OP13"],
    queryFn: () => fetchOP13(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    gcTime: 5 * 60 * 1000, // cache for 5 min if unfocused
    refetchInterval: 60 * 1000, // ← auto-update every minute
  });
